export enum MetadataFieldValueObjectTypes {
  DbAssetObjectInfos = "DbAssetObjectInfos",
  SolrAlContent = "SolrAlContent",
  SolrAlOeuvre = "SolrAlOeuvre",
  SolrAlOeuvreLocatorCast = "SolrAlOeuvreLocatorCast",
  SolrAlOeuvreLocatorSynopsis = "SolrAlOeuvreLocatorSynopsis",
  SolrAlOeuvreLocatorTitles = "SolrAlOeuvreLocatorTitles",
  DbOrderItemInfos = "DbOrderItemInfos",
  TranscodeBundleByProfile = "TranscodeBundleByProfile",
}
